import { Button } from "react-bootstrap";

const styles = {
  btn: {
    padding: ".429rem 1rem",
    margin: "0 .5rem",
    // marginTop: "1rem",
  },
};

export function UpdateButton({ disabled, onClick, text = "Update" }) {
  return (
    <Button
      style={{ ...styles.btn, backgroundColor: "#136C62" }}
      disabled={disabled}
      onClick={onClick}
      type="submit"
      className="btn-md theme-diva-primary-button"
    >
      {text}
    </Button>
  );
}

export function RefreshButton({
  disabled,
  onClick,
  text = "Retry",
  type = "button",
}) {
  return (
    <Button
      style={{ ...styles.btn, backgroundColor: "#F2B531", color: "#040404" }}
      disabled={disabled}
      onClick={onClick}
      type={type}
      className="btn-md theme-secondary-button"
    >
      {text}
    </Button>
  );
}
